import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Archive } from "lucide-react";

interface ArchiveConfirmationModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  agentName: string;
  isArchiving: boolean;
}

const ArchiveConfirmationModal = ({
  isOpen,
  onClose,
  onConfirm,
  agentName,
  isArchiving,
}: ArchiveConfirmationModalProps) => {
  return (
    <Dialog open={isOpen} onOpenChange={(open) => !open && onClose()}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <div className="flex items-center gap-3">
            <div className="p-2 bg-orange-100 rounded-lg">
              <Archive className="h-5 w-5 text-orange-600" />
            </div>
            <div>
              <DialogTitle>Archive Agent</DialogTitle>
              <DialogDescription className="mt-1">
                Archive "{agentName}"?
              </DialogDescription>
            </div>
          </div>
        </DialogHeader>
        
        <div className="py-4">
          <p className="text-sm text-gray-600 leading-relaxed">
            Archiving agents doesn't delete any knowledge or conversation data, and you'll be able to unarchive it at any time. 
            The agent will be moved to the archived section and won't be accessible to users.
          </p>
        </div>

        <DialogFooter className="flex gap-2">
          <Button
            variant="outline"
            onClick={onClose}
            disabled={isArchiving}
          >
            Cancel
          </Button>
          <Button
            onClick={onConfirm}
            disabled={isArchiving}
            className="bg-orange-600 hover:bg-orange-700 text-white"
          >
            {isArchiving ? (
              <>
                <div className="h-4 w-4 mr-2 animate-spin rounded-full border-2 border-white border-t-transparent"></div>
                Archiving...
              </>
            ) : (
              <>
                <Archive className="h-4 w-4 mr-2" />
                Archive Agent
              </>
            )}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default ArchiveConfirmationModal; 